import React from 'react';
import { X, PlayCircle } from 'lucide-react';
import './CardExpenseHelpModal.css';

interface Props {
  onClose: () => void;
  onStartTour: () => boolean;
}

const CardExpenseHelpModal: React.FC<Props> = ({ onClose, onStartTour }) => {
  return (
    <div className="ce-help-overlay" role="dialog" aria-modal="true" aria-labelledby="ce-help-title">
      <div className="ce-help-modal">
        <header>
          <h2 id="ce-help-title">Card expense categorization</h2>
          <button type="button" className="ce-help-close" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </header>
        <div className="ce-help-body">
          <p>
            Company debit card purchases sync from QuickBooks and route to the cardholder based on the card&apos;s last four digits.
          </p>
          <ul>
            <li><strong>Project</strong> — links the charge to that job, then pick the cost category (Travel, Install, Materials, etc.) for project P&amp;L. No sub-types (mileage vs. hotels) — one level only.</li>
            <li><strong>Purchase order</strong> — maps the charge to an issued PO and its proposal budget line. Several card charges can share one PO (tax, freight, or a split vendor bill).</li>
            <li><strong>Company overhead</strong> — shares the cost across projects via the overhead pool.</li>
            <li><strong>Leave unmatched</strong> — keeps it out of project totals until a PM assigns it.</li>
            <li><strong>Exclude from P&amp;L</strong> — dismisses personal charges, duplicates, or out-of-scope items from project totals entirely.</li>
          </ul>
          <p>
            Pending charges are excluded from Project P&amp;L until you save. By default you get a weekly Monday digest in the notification bell (opt in to daily under Settings). Auto-assigned overhead and excluded transfers are left out.
          </p>
        </div>
        <footer>
          <button
            type="button"
            className="ce-help-tour-btn"
            onClick={() => {
              onClose();
              window.setTimeout(() => onStartTour(), 200);
            }}
          >
            <PlayCircle size={16} aria-hidden />
            Replay walkthrough
          </button>
          <button type="button" className="ce-help-done-btn" onClick={onClose}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
};

export default CardExpenseHelpModal;
